import React, { useContext, useState } from 'react';
import { Form, Button, Alert, Row, Col, Spinner, Tab, Nav } from "react-bootstrap";
import { getStorage } from "@/utils/storage";
import BusinessKYCForm from "./business_kyc_form";
import BusinessDocumentsForm from "./business_documents_form";
import StatusTag from '@/components/Common/StatusTag';
import { STATUS_MAP } from "@/utils/constant";
import { custom_context } from "@/utils/custom_context";
import "../kyc.css";
const BusinessKyc = ({ loanDetails, businessKyc, reloadBusinessKyc, goToNextStep, documentsList, reloadDocumentsList }) => {
  const [activeTab, setActiveTab] = useState("details");
  const userData = getStorage("user_session")?.userDetails;
  const { applicationData } = useContext(custom_context.ApplicationData);
  const isCreditOfferApproved = applicationData?.evaluation?.status === "approved";

  const isKycReadonly = ['verified'].includes(businessKyc?.status) || isCreditOfferApproved;

  return (
    <div className="kycFlowContainer">
      <div className="kycFlowHeader flex justify-content-between align-center">
        <div>
          <h1>Incorporation details</h1>
          {
            ['input_required', 'rejected'].includes(businessKyc?.status) && businessKyc?.remarks ? <p className='text-danger'>{businessKyc?.remarks}</p> : <p>We need few details about your business</p>
          }

        </div>
        {businessKyc?.status && (
          <StatusTag status={businessKyc?.status || 'pending'} stepComplete={false} label={STATUS_MAP[businessKyc.status]?.label || "Pending"} />
        )}
      </div>
      {isCreditOfferApproved && (
        <div className="alert alert-info" role="alert">
          Business KYC cannot be added or edited after the credit offer has been approved.
        </div>
      )}
      <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="details" data-testid="fincobox-kyc-inner-tab-details">Business Details</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="documents" disabled={!businessKyc?.uuid} data-testid="fincobox-kyc-inner-tab-documents">
              Documents
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {/* {errors.general && <Alert variant="danger" className="mt-2">{errors.general}</Alert>} */}

        <Tab.Content className="p-2">
          {/* STEP 1 - DETAILS */}
          <Tab.Pane eventKey="details">
            <BusinessKYCForm
              loanDetails={loanDetails}
              userData={userData}
              isKycReadonly={isKycReadonly}
              goToNextStep={() => setActiveTab('documents')}
              business={businessKyc}
              reloadBusinessKyc={reloadBusinessKyc}
            />
          </Tab.Pane>

          {/* STEP 2 - DOCUMENTS */}
          <Tab.Pane eventKey="documents">
            <BusinessDocumentsForm
              isKycReadonly={isKycReadonly}
              goToNextStep={goToNextStep}
              business={businessKyc}
              reloadBusinessKyc={reloadBusinessKyc}
              goBack={() => setActiveTab('details')}
              documentsList={documentsList}
              reloadDocumentsList={reloadDocumentsList}
            />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  )
}

export default BusinessKyc;